import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { store } from 'store';

import ForgotPasswordForm from './ForgotPasswordForm';
import ResetPasswordForm from './ResetPasswordForm';
import { AuthScreen } from 'containers';
import { Link } from 'react-router-dom';
import { push } from 'connected-react-router';
import * as actions from 'actions';
import * as constants from 'common/constants';

class ForgotPassword extends PureComponent {
  state = {
    delivered: false,
  };

  resendEmail = () => {
    let message;
    let hasError = false;
    const forgotPasswordEmail = this.props.email;
    const values = { forgotPasswordEmail };

    try {
      this.onSubmitEmail(values);
      message = 'Email has been sent.';
    } catch (e) {
      message = 'An error occurred resending the email. Please try again.';
      hasError = true;
    }

    this.props.displayBanner(constants.BANNER_IDS.AUTH, message, hasError);
  };

  // Called when the user submits a validation code and a new password; should
  // take them to login screen and display a banner message on success
  onResetEmail = values => {
    const that = this;
    return this.props.resetPassword(values).then(() => {
      that.props.clearResetPasswordForm();
      that.props.displayBanner(
        constants.BANNER_IDS.AUTH,
        'Password updated successfully.'
      );
      store.dispatch(push('/'));
    });
  };

  // Called when a user submit their e-mail address to be sent a validation code
  // via e-mail; should transition to reset step on success
  onSubmitEmail = ({ forgotPasswordEmail }) => {
    const that = this;
    return this.props
      .forgotPassword({ forgotPasswordEmail })
      .then(() => {
        that.props.clearForgotPasswordForm();
        that.setState({ delivered: true, forgotPasswordEmail });
        that.props.displayBanner(
          constants.BANNER_IDS.AUTH,
          'Email has been sent.'
        );
      })
      .catch(e => {
        throw e;
      });
  };

  render() {
    const { email } = this.props;
    return (
      <AuthScreen
        header={
          <Fragment>
            <h1 className={'text--header'}>
              {this.state.delivered ? 'RESET PASSWORD' : 'FORGOT PASSWORD'}
            </h1>
            <span className={'text---fade'}>
              or <Link to="/">Sign in</Link>
            </span>
          </Fragment>
        }
        headersub={
          this.state.delivered
            ? 'Please choose a new password to finish password reset.'
            : 'Enter your email below to reset your password.'
        }
      >
        {this.state.delivered ? (
          <Fragment>
            <div className="confirm-email__text">
              <p>
                We have sent a verification code to{' '}
                <span className={'text--primary'}>{email}</span>. Please check
                your email and enter the passcode below.
              </p>
              <p>
                Didn&apos;t receive your email yet? Please check your spam
                folder or
                <a onClick={this.resendEmail}> resend</a> the email.
              </p>
            </div>
            <ResetPasswordForm onSubmit={this.onResetEmail} />
          </Fragment>
        ) : (
          <ForgotPasswordForm onSubmit={this.onSubmitEmail} />
        )}
      </AuthScreen>
    );
  }
}

ForgotPassword.propTypes = {
  email: PropTypes.string.isRequired,
  resetPassword: PropTypes.func.isRequired,
  displayBanner: PropTypes.func.isRequired,
  forgotPassword: PropTypes.func.isRequired,
  clearResetPasswordForm: PropTypes.func.isRequired,
  clearForgotPasswordForm: PropTypes.func.isRequired,
};

const mapState = ({ auth }) => ({
  email: auth.email,
});

const mapDispatch = {
  resetPassword: actions.auth.resetPassword,
  forgotPassword: actions.auth.forgotPassword,
  clearResetPasswordForm: () => reset('resetPassword'),
  clearForgotPasswordForm: () => reset('forgotPassword'),
  displayBanner: actions.banner.display,
};

export default connect(
  mapState,
  mapDispatch
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/pages/ForgotPassword/index.js